export default __webpack_public_path__ + "static/media/burger.1180c456.svg";